import { PROGRESS_WINDOW, GAME_ID, REDUX_ACTIONS, NUM_STANDARD_BACKGROUNDS } from 'a/cutItOut/data/constants';

export const initialState = {
  currentActivityWindow: PROGRESS_WINDOW,
  bgIndexes: [],
  currentBgIndex: null,
};

const activityReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_ACTIVITY_WINDOW:
      return {
        ...state,
        currentActivityWindow: action.payload.window,
      };
    case REDUX_ACTIONS.INIT_BACKGROUNDS: {
      const { bgIndexes } = action.payload;
      return {
        ...state,
        bgIndexes,
      };
    }
    case REDUX_ACTIONS.SET_CURRENT_BACKGROUND: {
      const { levelId } = action.payload;
      return {
        ...state,
        currentBgIndex: state.bgIndexes[levelId % NUM_STANDARD_BACKGROUNDS],
      };
    }
    default:
      return state;
  }
};

export default activityReducer;
